import React, { useState, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import SectionLabel from '../components/SectionLabel';
import PhotoTile from '../components/PhotoTile';
import Skeleton from '../components/Skeleton';
import { fetchPhotos, useLive } from '../data/live';

export default function GalleryPage() {
  const { meeting } = useOutletContext();
  const event = meeting._event;

  const live = useLive(fetchPhotos, [event?.id]);
  const [filter, setFilter] = useState('All');

  // Memoized on the stable `live` value so the categories don't recompute
  // (or trip exhaustive-deps) on every render.
  const photos = useMemo(() => live || [], [live]);
  const categories = useMemo(() => {
    const labels = photos.map((p) => p.label).filter(Boolean);
    const set = new Set(labels);
    return set.size > 1 ? ['All', ...Array.from(set)] : [];
  }, [photos]);

  const filtered = filter === 'All' || !categories.length
    ? photos
    : photos.filter((p) => p.label === filter);

  if (live === undefined) return <Skeleton variant="tile" count={6} />;

  return (
    <>
      {categories.length > 0 && (
        <div className="portal-photo-filter">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              className={`portal-photo-chip${filter === c ? ' active' : ''}`}
              onClick={() => setFilter(c)}
            >
              {c}
            </button>
          ))}
        </div>
      )}

      <SectionLabel right={`${filtered.length}`}>Photos</SectionLabel>

      {filtered.length > 0 ? (
        <div className="portal-photo-grid">
          {filtered.map((p, i) => <PhotoTile key={i} photo={p} />)}
        </div>
      ) : (
        <div className="portal-overview-body">Photos coming soon.</div>
      )}
    </>
  );
}
